
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { InstitutioninforApi, UserprojectdatarelationApi } from "@newview/nvsystem-api";
import { grid, vxeGrid } from "@newview/ui";

@Component({
  components: {
    grid, vxeGrid
  },
})
export default class SelectUser extends BaseVue {

  institutioninforApi: InstitutioninforApi = new InstitutioninforApi();
  userprojectdatarelationApi: UserprojectdatarelationApi = new UserprojectdatarelationApi();
  @Prop({ default: 0 }) type!: any; //子系统Id 用于项目及机构 非项目级机构传0
  @Prop({ default: [] }) selectUserInfo!: any; //选中的人员Id 用来反选
  @Prop({ default: [] }) visible!: any;
  @Prop({ default: [] }) data!: any; // 已选的人员

  treeData1: any = [];
  treeData2: any = [];
  selGridData: any = [];
  gridData: any = [];
  SpinShow1 = false;
  SpinShow2 = false;
  selectOrgIds: any = [];
  institutionList: any = []
  deductionColConfig =
    [
      { key: "institutionName", title: "机构", align: "center" },
      { key: "roleName", title: "岗位", align: "center" },
      { key: "userName", title: "人员", align: "center" },
    ];

  treeviewSelectedData;
  rowOperation = {
    isEditBtn: false,
    isDelBtn: false,
    cellW: 60,
    otherBtn: [{ name: "移除", clickEvent: this.removeSelRow }],
  };
  defaultOrgIds: any = []
  // 已选人员删除
  removeEle(item) {
    this.selGridData.splice(this.selGridData.indexOf(item), 1)

  }
  openDialog() {
    this.selGridData = this.data.map(item => {
      return { ...item, userName: item.name,userId:item.targetId }
    })
    this.treeData2 = []
    this.loadTreeView1()

  }
  //移除已选择的行
  removeSelRow(item) {
    this.selGridData.splice(this.getIndexByGridData(item.userId), 1);
    this.selectUserInfo.splice(this.getIndexByGridData(item.userId), 1);
    this.changeTreeData(item.userId, "checked", false);
  }
  //修改树中数据
  changeTreeData(Id, key, value, data: any = 0) {
    let treeData = data == 0 ? this.treeData2 : data;
    for (let item of treeData) {
      if (item.userId == Id) {
        this.$set(item, key, value);
      }
      if (item.children && item.children.length > 0) {
        this.changeTreeData(Id, key, value, item.children);
      }
    }
  }
  //获取指定行的序号
  getIndexByGridData(Id) {
    let returnIndex = -1;
    this.selGridData.forEach(function (item, index) {
      if (Id == item.userId) {
        returnIndex = index;
        return;
      }
    });
    return returnIndex;
  }
  // 机构树数据
  async loadTreeView1() {
    let datas: any =
        await this.institutioninforApi.getInstitutionTreeBySubProjectIdNew(
            this.$store.state.projectId
        );
    if (datas.code == 200) {
      if (datas.data.length > 0) {
        for (const iterator of datas.data) {
          iterator.pid = iterator.pId;
        }
      }
      let das = this.getIViewTreeDataJ(datas.data, "institutionName");
      this.treeData1 = das;
    }
    // console.log(this.data)
    // this.SpinShow1 = true;
    // const _this = this;
    // const res: any = await this.institutioninforApi.getInstitutionTreeBySubProjectIdNew(this.$store.state.projectId);
    // debugger
    // if (res.code == 200) {
    //   const datas = res.data;
    //   let treeViewData = JSON.parse(JSON.stringify(datas))
    //   this.defaultOrgIds = this.Baselinq.from(treeViewData).select((item) => item["id"]).toArray()
    //   datas.map(e => e.pid = e.PId)
    //   let newDatas = datas.filter(e=>e.isMain==1)
    //   newDatas.push(datas[0])
    //   this.treeData1 = this.getIViewTreeDataJ(newDatas, 'institutionName');
    //   this.SpinShow1 = false;
    //
    //   setTimeout(() => {
    //     this.selectNodes()
    //   }, 200);
    // }
  }
  // 岗位/人员树数据
  async loadTreeView2() {
    this.treeData2 = []
    this.SpinShow2 = true;
    //TODO  获取子系统Id  孙
    const res = await this.userprojectdatarelationApi.getUserRoleList(this.selectOrgIds.join());
    if (res.code == 200) {
      const data = this.getIViewTreeDataJ(res.data, 'nodeName');
      this.setDisableCheckbox(data);
      this.treeData2 = data.map(item=>{
        this.selGridData.forEach(p=>{
          item.children.forEach(ch=>{
            if(ch.nodeName === p.userName) ch.checked = true
          })
        })
        return item
      })
      console.log(this.treeData2)
      
    }
    this.SpinShow2 = false;
  }
  async closeDialog() {
    this.selGridData = []
    this.$emit('update:visible', false)
  }
  saveGriData() {
    
    const checkList = this.selGridData.map(item => {
      return { name: item.userName || item.roleName, type: item.userName ? 1 : 3, targetId: item.userId }
    })

    this.$emit('change', checkList)
    this.closeDialog()
  }

  async mounted() {
    this.loadTreeView1();
  }
  // 默认选中
  async selectNodes() {

  }
  setSelectedTreeById(treeData, id) {
    treeData.forEach((item, index) => {
      if (item.Id == id) {
        this.$set(item, "selected", true);
      } else {
        this.$set(item, "selected", false);
      }
      if (item.children && item.children.length > 0) {
        this.setSelectedTreeById(item.children, id)
      }
    });
  }
  //机构树点击事件
  selectOrgTree(selectedNodes, item) {

    this.institutionList = selectedNodes
  
    let res: any = this.gridData.filter(e => e.pid == item.id);
    for (const iterator of this.gridData) {
      if (iterator.id == item.id && res.length == 0) {
        this.$set(iterator, "checked", true)
      }
    }
    this.selectOrgIds = this.Baselinq.from(selectedNodes).select((item) => item["id"]).toArray()
    this.loadTreeView2();
  }

  //岗位/角色树复选框事件
  checkRoleUser(checkedNodes, item) {
    if (item.checked) {
      let objData: any = {};
      objData.institutionName = item.institutionName;
      objData.roleName = item.roleName;
      objData.roleId = item.pid;  //为角色id
      objData.userName = item.nodeName;
      objData.userId = item.userId;
      objData.userPhone = item.userPhone;
      objData.institutionId = item.institutionId;
      this.selGridData.push(objData);
      this.selectUserInfo.push(objData);
    } else {
      this.removeSelRow(item);
    }
  }
  // 获取已选择的数据集合
  getSelData() {
    if (this.type == 1) {
      return this.institutionList;
    } else {
      return this.selGridData;
    }
  }
  setDisableCheckbox(data) {//递归屏蔽父结点复选框
    let treeData: any = data;
    for (let item of treeData) {
      if (item.children && item.children.length > 0) {
        this.$set(item, "disableCheckbox", true);
        this.setDisableCheckbox(item.children);
      }
    }
  }
}
